/**
 * Hole In One Golf — Cart Drawer JS
 * Vanilla JS using Shopify AJAX Cart API.
 */

(function () {
  'use strict';

  let lastActiveElement = null;

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function getScrim() {
    return document.querySelector('[data-cart-scrim]');
  }

  function openCart(trigger) {
    const drawer = getDrawer();
    const scrim = getScrim();
    if (!drawer || !scrim) return;

    if (trigger) {
      lastActiveElement = trigger;
    } else if (!lastActiveElement) {
      lastActiveElement = document.activeElement;
    }

    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    scrim.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    const closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn && typeof closeBtn.focus === 'function') {
      closeBtn.focus();
    }
  }

  function closeCart() {
    const drawer = getDrawer();
    const scrim = getScrim();
    if (!drawer || !scrim) return;

    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
      lastActiveElement = null;
    }
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update all cart count badges
        const badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });

        // Re-fetch page to get updated cart drawer markup
        return fetch(window.location.href)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('[data-cart-drawer]');
            const curDrawer = getDrawer();
            if (newDrawer && curDrawer) {
              const activeEl = document.activeElement;
              let focusSelector = null;
              if (activeEl && curDrawer.contains(activeEl)) {
                if (activeEl.hasAttribute('data-cart-close')) {
                  focusSelector = '[data-cart-close]';
                } else if (activeEl.hasAttribute('data-cart-remove')) {
                  const key = activeEl.getAttribute('data-cart-remove');
                  focusSelector = '[data-cart-remove="' + key + '"]';
                } else if (activeEl.hasAttribute('data-cart-change-qty')) {
                  const key = activeEl.getAttribute('data-item-key');
                  const isIncrease = activeEl.getAttribute('aria-label') === 'Increase quantity';
                  focusSelector = isIncrease
                    ? '[data-cart-change-qty][data-item-key="' + key + '"][aria-label="Increase quantity"]'
                    : '[data-cart-change-qty][data-item-key="' + key + '"][aria-label="Decrease quantity"]';
                }
              }

              curDrawer.innerHTML = newDrawer.innerHTML;
              attachDrawerListeners();

              // If drawer is open during markup replacement, restore focus to equivalent element or close button
              if (curDrawer.classList.contains('is-open')) {
                let restored = false;
                if (focusSelector) {
                  const target = curDrawer.querySelector(focusSelector);
                  if (target && typeof target.focus === 'function') {
                    target.focus();
                    restored = true;
                  }
                }
                if (!restored) {
                  const fallback = curDrawer.querySelector('[data-cart-close]');
                  if (fallback && typeof fallback.focus === 'function') {
                    fallback.focus();
                  }
                }
              }
            }
          });
      })
      .catch(function (err) {
        console.error('Failed to update cart', err);
      });
  }

  function attachDrawerListeners() {
    const drawer = getDrawer();
    if (!drawer) return;

    // Close buttons
    drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.onclick = closeCart;
    });

    // Remove buttons
    drawer.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.onclick = function () {
        const key = btn.getAttribute('data-cart-remove');
        changeItem(key, 0);
      };
    });

    // Quantity buttons
    drawer.querySelectorAll('[data-cart-change-qty]').forEach(function (btn) {
      btn.onclick = function () {
        const key = btn.getAttribute('data-item-key');
        const qty = parseInt(btn.getAttribute('data-cart-change-qty'), 10);
        changeItem(key, Math.max(0, qty));
      };
    });
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return refreshCart();
      })
      .catch(function (err) {
        console.error('Failed to change item quantity', err);
      });
  }

  function initGlobalListeners() {
    // Open cart triggers
    document.addEventListener('click', function (e) {
      const openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) {
        e.preventDefault();
        openCart(openBtn);
        return;
      }

      const closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn) {
        e.preventDefault();
        closeCart();
        return;
      }

      if (e.target.matches('[data-cart-scrim]')) {
        closeCart();
      }
    });

    // Keyboard navigation focus loop
    document.addEventListener('keydown', function (e) {
      const drawer = getDrawer();
      if (!drawer || !drawer.classList.contains('is-open')) return;

      if (e.key === 'Escape') {
        closeCart();
        return;
      }

      if (e.key === 'Tab') {
        const focusables = Array.from(drawer.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) {
          return el.offsetParent !== null;
        });

        if (focusables.length === 0) {
          e.preventDefault();
          return;
        }

        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // Form submissions for add to cart
    document.addEventListener('submit', function (e) {
      const form = e.target.closest('form[action*="/cart/add"], [data-quick-add-form]');
      if (form) {
        e.preventDefault();
        const submitBtn = form.querySelector('button[type="submit"]') || e.submitter || document.activeElement;
        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            return refreshCart();
          })
          .then(function () {
            openCart(submitBtn);
          })
          .catch(function (err) {
            console.error('Failed to add product to cart', err);
          });
      }
    });

    // Quantity selectors on PDP
    document.addEventListener('click', function (e) {
      const minus = e.target.closest('[data-quantity-minus]');
      if (minus) {
        const wrap = minus.closest('[data-quantity-wrapper]');
        const input = wrap ? wrap.querySelector('input[type="number"]') : null;
        if (input) {
          const val = Math.max(parseInt(input.min || '1', 10), parseInt(input.value || '1', 10) - 1);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      const plus = e.target.closest('[data-quantity-plus]');
      if (plus) {
        const wrap = plus.closest('[data-quantity-wrapper]');
        const input = wrap ? wrap.querySelector('input[type="number"]') : null;
        if (input) {
          const val = Math.min(parseInt(input.max || '99', 10), parseInt(input.value || '1', 10) + 1);
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGlobalListeners();
      attachDrawerListeners();
    });
  } else {
    initGlobalListeners();
    attachDrawerListeners();
  }
})();
